import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { dashboardLayoutComponent } from '@/routes/layouts/dashboard-layout-route';

export const profileRoute = createRoute({
  getParentRoute: () => dashboardLayoutComponent,
  path: '/profile',
  component: lazyRouteComponent(() => import('@/pages/profile/my-profile/profile-page')),
});
